import Layout from "../../components/Layout";
import { Helmet } from "react-helmet-async";
import {
  FiClipboard,
  FiTruck,
  FiUsers,
  FiBarChart2,
  FiDollarSign,
  FiBriefcase,
  FiSettings,
  FiCheckCircle,
} from "react-icons/fi";

const IndustryConstruction = () => {
  const trackCTA = () => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "Sign Up - Construction Industry Page",
      });
    }
  };

  return (
    <Layout>
      <Helmet>
        <title>Construction Industry | RedERP</title>
        <meta
          name="description"
          content="Discover how RedERP helps construction companies streamline site progress, subcontractor management, procurement, and financials in one smart ERP platform."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white py-20">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-10">
          <div className="flex-1 text-left">
            <h1 className="text-4xl font-bold mb-4">ERP for Construction Companies</h1>
            <p className="mb-6 text-sm sm:text-base">
              From estimation to handover, RedERP helps you manage every construction phase with confidence and control.
            </p>
            <a
              href="https://app.rederp.pro/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackCTA}
              className="inline-block bg-white text-primary font-semibold px-6 py-3 rounded-full hover:bg-gray-100"
            >
              Get Started Now
            </a>
          </div>
          <div className="flex-1 hidden md:flex justify-end">
            <img
              src="/assets/images/construction-industry.png"
              alt="Construction Industry"
              className="w-[400px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Modules Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto text-center mb-10">
          <h2 className="text-3xl font-bold text-primary mb-3">
            Core Modules for Construction Firms
          </h2>
          <p className="text-gray-600">
            Plan, build, and deliver more efficiently with fully integrated modules tailored for construction workflows.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-left max-w-6xl mx-auto">
          {[
            {
              icon: <FiClipboard size={24} />,
              title: "Project Management",
              desc: "Track site progress, allocate teams, manage Gantt charts, and ensure timely delivery.",
            },
            {
              icon: <FiTruck size={24} />,
              title: "Procurement & Logistics",
              desc: "Manage supplier quotes, purchase orders, and delivery to various construction sites.",
            },
            {
              icon: <FiUsers size={24} />,
              title: "HR & Field Workforce",
              desc: "Handle labor attendance, contractor shifts, time logs, and on-site permissions.",
            },
            {
              icon: <FiDollarSign size={24} />,
              title: "Finance & Budgeting",
              desc: "Control budgets, track expenses, generate reports, and invoice clients or subcontractors.",
            },
            {
              icon: <FiBarChart2 size={24} />,
              title: "Reporting & KPIs",
              desc: "Monitor project profitability, job costing, and resource utilization via dashboards.",
            },
            {
              icon: <FiSettings size={24} />,
              title: "CRM & Tender Management",
              desc: "Track RFPs, proposals, pipeline of tenders, and manage relationships with developers.",
            },
          ].map((mod, i) => (
            <div
              key={i}
              className="p-6 bg-gray-50 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex items-center gap-3 text-primary mb-3">
                {mod.icon}
                <h3 className="font-bold">{mod.title}</h3>
              </div>
              <p className="text-sm text-gray-600">{mod.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-10 py-16">
          <div className="flex-1 text-left">
            <h3 className="text-3xl font-bold mb-4">Build Smarter with RedERP</h3>
            <p className="mb-6 text-sm sm:text-base">
              From large-scale contractors to home builders, RedERP helps construction teams scale with less admin work.
            </p>
            <a
              href="https://app.rederp.pro/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackCTA}
              className="inline-block bg-white text-primary font-semibold px-6 py-3 rounded-full hover:bg-gray-100"
            >
              Try RedERP for Construction
            </a>
          </div>
          <div className="flex-1 hidden md:flex justify-end">
            <img
              src="/assets/images/cta2.png"
              alt="Construction CTA"
              className="w-[360px] object-contain"
            />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default IndustryConstruction;
